import React, { Component } from 'react';
import PropTypes from 'prop-types';
import bulmaCalendar from 'bulma-calendar';
import $ from 'jquery';

import Input from './Input';
import InputDate from './InputDate';
import Radio from './Radio';
import Select from './Select';

const initMultiSelect = (discipline, classYear) => {
  const $selectDiscipline = $('select[multiple]#news-events-discipline');
  const $selectClassYear = $('select[multiple]#news-events-class-year');

  $selectDiscipline.multiselect({
    placeholder: 'Disciplines/Majors'
  });

  $selectClassYear.multiselect({
    placeholder: 'Class Year',
    onOptionClick: () => {
      const selectedOptions = $('select[multiple]#news-events-class-year').val();
      const btnClear = document.querySelector('.btn-clear');
      if (selectedOptions.length === 0) {
        $('#ms-list-2 > button').html('<span>Class Year</span>');
      } else {
        $('#ms-list-2 > button').html(selectedOptions.join(', '));
        btnClear.classList.remove('is-hidden');
      }
    }
  });

  // handle discipline if params exist in query
  if (discipline.length !== 0) {
    const disciplineArray = discipline.split(',');

    $selectDiscipline.val(disciplineArray).prop('checked', true);
    $('#ms-list-1').addClass('ms-has-selections');
    $('#ms-list-1 > button').html(disciplineArray.join(', '));
    disciplineArray.forEach(item => {
      const selectedInput = $(`input[value="${item}"]`);
      selectedInput
        .prop('checked', true)
        .parent()
        .parent()
        .addClass('selected');
    });
  }

  // handle class year if params exist in query
  if (classYear.length !== 0) {
    const classYearArray = classYear.split(',');

    $selectClassYear.val(classYearArray).prop('checked', true);
    $('#ms-list-2').addClass('ms-has-selections');
    $('#ms-list-2 > button').html(classYearArray.join(', '));
    classYearArray.forEach(item => {
      const selectedInput = $(`input[value="${item}"]`);
      selectedInput
        .prop('checked', true)
        .parent()
        .parent()
        .addClass('selected');
    });
  }
};

const classYears = year => {
  const currentYear = new Date().getFullYear();
  const years = [];
  let startYear = year || currentYear - 80;
  while (startYear <= currentYear) {
    // eslint-disable-next-line no-plusplus
    years.push(`${startYear++}`);
  }
  const sortedYears = years.sort((a, b) => b - a);
  return sortedYears;
};

const initInputDate = (dateStart, dateEnd) => {
  const dateOptions = {
    type: 'date',
    color: 'black',
    isRange: true,
    showHeader: false,
    showFooter: false,
    toggleOnInputClick: true,
    displayMode: 'dialogue',
    startDate: dateStart,
    endDate: dateEnd,
    onReady: datepicker => {
      const wrapper = document.querySelector(
        `#${datepicker.data.id} .datetimepicker-dummy-wrapper`
      );
      const input = document.querySelectorAll(`#${datepicker.data.id} .datetimepicker-dummy-input`);
      const clearBtn = document.querySelector(
        `#${datepicker.data.id} .datetimepicker-clear-button`
      );

      if (dateStart.length > 0 || dateEnd.length > 0) {
        clearBtn.classList.add('is-block');
        input[1].classList.add('icon-hidden', 'selected');
        wrapper.classList.add('selected', 'placeholder-hidden');
        input[0].value = `${typeof dateStart !== 'undefined' ? dateStart : ''}`;
        input[1].value = `${typeof dateEnd !== 'undefined' ? dateEnd : ''}`;
      }
    }
  };

  // Initialize all input of date type.
  bulmaCalendar.attach('[type="date"]', dateOptions);

  // // To access to bulmaCalendar instance of an element
  const element = document.querySelector('#news-events-event-date');

  if (element) {
    // bulmaCalendar instance is available as element.bulmaCalendar
    element.bulmaCalendar.on('select:start', datepicker => {
      const wrapper = document.querySelector(
        `#${datepicker.data.id} .datetimepicker-dummy-wrapper`
      );
      const input = document.querySelectorAll(`#${datepicker.data.id} .datetimepicker-dummy-input`);
      const clearBtn = document.querySelector(
        `#${datepicker.data.id} .datetimepicker-clear-button`
      );
      wrapper.classList.add('placeholder-hidden');

      clearBtn.classList.add('is-block');
      input[1].classList.add('icon-hidden', 'selected');
      wrapper.classList.add('selected');

      clearBtn.addEventListener('click', e => {
        e.preventDefault();
        clearBtn.classList.remove('is-block');
        wrapper.classList.remove('placeholder-hidden', 'selected');
        input[1].classList.remove('icon-hidden');
      });
    });
  }
};

export default class NewsEventsForm extends Component {
  constructor(props) {
    super(props);

    this.filterDisciplines = this.filterDisciplines.bind(this);
    this.disableCalendar = this.disableCalendar.bind(this);
  }

  componentDidMount() {
    const { discipline, classYear, eventDateRangeStart, eventDateRangeEnd } = this.props;
    initMultiSelect(discipline, classYear);
    initInputDate(eventDateRangeStart, eventDateRangeEnd);
    this.disableCalendar();
  }

  componentDidUpdate(prevProps) {
    const { filter } = this.props;

    if (prevProps.filter !== filter) {
      this.disableCalendar();
    }
  }

  filterDisciplines() {
    const { termsDisciplines } = this.props;
    const disciplineArray = [];
    const sortedArray = disciplineArray.sort((a, b) => a.localeCompare(b));

    termsDisciplines.map(d => {
      disciplineArray.push(d.name);
    });

    return sortedArray;
  }

  disableCalendar() {
    const { filter } = this.props;
    const calendar = document.querySelector('.datetimepicker-dummy').parentNode;

    if (filter === 'news') {
      calendar.classList.add('disabled');
    } else {
      calendar.classList.remove('disabled');
    }
  }

  render() {
    const {
      clearFilters,
      handleRadio,
      handleSubmit,
      filter,
      search,
      eventLocation,
      ready
    } = this.props;

    if (!ready) return null;
    return (
      <form action="#" className="news-events-form">
        <div className="columns">
          <div className="column">
            <div className="news-events-radio-wrap">
              <div className="news-events-radio control">
                Showing:
                <Radio
                  id="news-events-radio-all"
                  btnText="all"
                  name="showing"
                  value="all"
                  handleChange={handleRadio}
                  checked={filter === 'all'}
                />
                <Radio
                  id="news-events-radio-news"
                  btnText="news"
                  name="showing"
                  value="news"
                  handleChange={handleRadio}
                  checked={filter === 'news'}
                />
                <Radio
                  id="news-events-radio-events"
                  btnText="events"
                  name="showing"
                  value="events"
                  handleChange={handleRadio}
                  checked={filter === 'events'}
                />
              </div>
            </div>
          </div>
          <div className="column">
            <Select
              id="news-events-discipline"
              placeHolder="Disciplines/Majors"
              options={this.filterDisciplines()}
              multi
            />
          </div>
          <div className="column">
            <InputDate id="news-events-event-date" placeHolder="Events by Date" />
          </div>
        </div>
        <div className="columns">
          <div className="column">
            <Input
              id="news-events-search"
              icon="search"
              placeHolder="Search for People, Topics, Etc."
              defaultValue={search}
            />
          </div>
          <div className="column">
            <Select
              id="news-events-class-year"
              placeHolder="Class Year"
              options={classYears()}
              multi
            />
          </div>
          <div className="column">
            <Input
              id="news-events-event-location"
              icon="location"
              placeHolder="Events By Location"
              disabled={filter === 'news'}
              defaultValue={eventLocation}
            />
          </div>
        </div>
        <button type="button" className="btn btn-inverse" onClick={e => handleSubmit(e)}>
          Apply Filters
        </button>
        <button type="button" className="btn btn-unstyled btn-clear" onClick={e => clearFilters(e)}>
          Clear All Filters
        </button>
      </form>
    );
  }
}

NewsEventsForm.propTypes = {
  clearFilters: PropTypes.func.isRequired,
  classYear: PropTypes.string.isRequired,
  discipline: PropTypes.string.isRequired,
  eventLocation: PropTypes.string.isRequired,
  eventDateRangeStart: PropTypes.string.isRequired,
  eventDateRangeEnd: PropTypes.string.isRequired,
  filter: PropTypes.string.isRequired,
  handleRadio: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired,
  terms: PropTypes.arrayOf(PropTypes.object).isRequired,
  termsDisciplines: PropTypes.arrayOf(PropTypes.object).isRequired,
  discipline: PropTypes.string.isRequired
};
